// extracted by mini-css-extract-plugin
export default {"button":"SubActionButton_button__9mFM+","icon":"SubActionButton_icon__XQTq+","child":"SubActionButton_child__cHMrx"};